export const useSession = () => {
  const saveSession = session => sessionStorage.setItem('session', session)

  const getSession = () => sessionStorage.getItem('session')

  const deleteSession = () => sessionStorage.removeItem('session')

  return {
    saveSession,
    getSession,
    deleteSession,
  }
}
